import { dataLayer } from './dataLayer';
import { memberStorage } from './memberStorage';

export const virtualPageview = ($ngRedux, $location, $transitions) => {
  'ngInject';

  if (process.env.NODE_ENV !== 'development') {
    $transitions.onSuccess('*', $transition$ => {
      const { voomeProductId, memberId } = memberStorage.get();
      const path = $location.path();
      const absUrl = $location.absUrl();
      const virtualUrl = absUrl.substring(absUrl.indexOf(path));
      const visitorType = memberId ? 'Member' : 'Non Member';
      const pageType = $transition$.to().authenticate
        ? 'Logged in'
        : 'Not Logged in';

      dataLayer.track('virtualPageView', {
        virtualUrl,
        visitorType,
        pageType,
        voomeProductId,
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/utils/virtualPageview.js